import React, {useContext, useEffect, useState} from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import Alert from "../../../../../components/alert/alert.jsx";
import {IndividualContext} from "../individual-context.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useRequiredTabErrors} from "../../../../../hooks/use-required-tab-errors.js";

const tabs = [
    { key: "resume", label: "Resumo"},
    { key: "general", label: "Informações pessoais"},
    { key: "characteristics", label: "Características"},
    { key: "addresses", label: "Endereços"},
    { key: "other-information", label: "Outras informações"},
    { key: "articles", label: "Artigos indiciados"},
    { key: "phones", label: "Telefones"},
    { key: "photos", label: "Fotos"},
    { key: "attachments", label: "Anexos"},
]

const AssociationCountBadge = ({count}) => {
    if (!count) return null;

    return (
        <span className="absolute top-0.75 right-0.5 bg-[#1588f3] rounded-full min-w-4.25 h-4.25 px-1 text-white flex items-center justify-center text-[10px] font-bold">
            {count > 99 ? "99+" : count}
        </span>
    );
}

const Analyses = ({tabSelected, setTabSelected, navigate, hasRequiredTabError}) => {
    const {permissions, cpf} = useContext(IndividualContext)

    const openNetwork = () => {
        const urlDev = `/association-network/form?cpf=${cpf}`;
        navigate(urlDev, true)
    }

    return (
        <>
            <hr className={"text-[#ededed]"}/>
            <h3 className="px-[3px] flex gap-3 flex-col select-none mb-1">Análises</h3>

            {
                permissions.analysesNetworkPermission &&
                <p className={`flex items-center justify-between cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3]`}
                   onClick={openNetwork}>
                    Rede de associação
                    <FaExternalLinkAlt/>
                </p>
            }
            <p className={`relative box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === "activity-map" ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError("activity-map") ? "border border-[#dc2626]" : ""}`}
               onClick={() => setTabSelected("activity-map")}>
                Mapa de atividade
            </p>
        </>
    )

}

const Associations = ({tabSelected, setTabSelected, hasRequiredTabError}) => {
    const {individualInfo, boName, permissions} = useContext(IndividualContext)
    const hasAssociationPermission = permissions.encounterPermission || permissions.boPermission || permissions.occPermission || permissions.sosPermission;

    if (!hasAssociationPermission) return null;

    return (
        <>

            <hr className={"text-[#ededed]"}/>
            <h3 className="px-[3px] flex gap-3 flex-col select-none mb-1">Associações</h3>

            {
                permissions.encounterPermission &&
                <p className={`relative box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === "encounters" ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError("encounters") ? "border border-[#dc2626]" : ""}`}
                   onClick={() => setTabSelected("encounters")}>
                    Abordagem
                    <AssociationCountBadge count={individualInfo?.encounters?.length}/>
                </p>
            }

            {
                permissions.boPermission &&
                <p className={`relative box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === "bos" ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError("bos") ? "border border-[#dc2626]" : ""}`}
                   onClick={() => setTabSelected("bos")}>
                    {boName}
                    <AssociationCountBadge count={individualInfo?.bos?.length}/>
                </p>
            }

            {
                permissions.occPermission &&
                <p className={`relative box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === "occurrences" ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError("occurrences") ? "border border-[#dc2626]" : ""}`}
                   onClick={() => setTabSelected("occurrences")}>
                    Ocorrência
                    <AssociationCountBadge count={individualInfo?.occurrences?.length}/>
                </p>
            }

            {
                permissions.sosPermission &&
                <p className={`relative box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === "sos" ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError("sos") ? "border border-[#dc2626]" : ""}`}
                   onClick={() => setTabSelected("sos")}>
                    SOS
                    <AssociationCountBadge count={individualInfo?.sos?.length}/>
                </p>
            }
        </>
    )
}

const Tabs = ({tabSelected, setTabSelected}) => {
    const {changes, cpf} = useContext(IndividualContext)
    const navigate = navigateHook();
    const tabKeys = [...tabs.map(({key}) => key), "encounters", "bos", "occurrences", "sos", "activity-map"];
    const {hasRequiredTabError} = useRequiredTabErrors({
        tabKeys,
        tabSelected,
        setTabSelected,
    });

    return (
        <Card className={"flex-1 min-h-0 flex flex-col"}>
            <Card.Body className={"flex-1 min-h-0 flex flex-col gap-2"}>
                <div className={"grid grid-cols-12 gap-4 flex-1 min-h-0"}>
                    <div className={"col-span-12 h-full overflow-auto"}>
                        {
                            tabs.map(({key, label}, index) => {
                                const keyFind = changes.find(c => c === key);
                                return (
                                    <p key={index} className={`box-border cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === key ? "bg-[#d3d3d3]" : ""} ${hasRequiredTabError(key) ? "border border-[#dc2626]" : ""}`}
                                       onClick={() => setTabSelected(key)}>
                                        {label}
                                        <span className={"ms-1"}>{keyFind ? "*" : ""}</span>
                                    </p>
                                )
                            })
                        }

                        {cpf && <Associations tabSelected={tabSelected} setTabSelected={setTabSelected} hasRequiredTabError={hasRequiredTabError}/>}
                        {cpf && <Analyses tabSelected={tabSelected} setTabSelected={setTabSelected} navigate={navigate} hasRequiredTabError={hasRequiredTabError}/>}

                    </div>
                </div>

                {
                    changes.length > 0 &&
                    <Alert target={"warning"}>
                        <span className={"text-[14px]"}>* Salve suas alterações antes de sair</span>
                    </Alert>
                }
            </Card.Body>
        </Card>
    );
};

export default Tabs;